<template>
    <div class="container">
        <img v-if="footerImage1.display" :src="footerImage1.url" alt="" width="85%">
        <img v-if="footerImage2.display" :src="footerImage2.url" alt="" width="70%" style="padding-top: 10px;">
        <div v-if="copywriteDisplay" v-html="copywriteText"></div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { FooterImagesItem } from '@/view/home/supportScript';
import { useGameStore } from '@/stores/games';

function resolveText(text: string | Record<string, string>): string {
  if (typeof text === 'string') return text
  const lang = localStorage.getItem('lang') || 'en'
  return text[lang] || text['en'] || ''
}

function resolveImage(item: FooterImagesItem | Record<string, FooterImagesItem>): FooterImagesItem {
  if (!item) return { display: false, url: '', redirectUrl: '' }
  if ('url' in item) return item as FooterImagesItem
  const lang = localStorage.getItem('lang') || 'en'
  const localized = item as Record<string, FooterImagesItem>
  return localized[lang] || localized['en'] || { display: false, url: '', redirectUrl: '' }
}

const gameStore = useGameStore()
const props = defineProps<{
    itemData: {
        footerImage1: FooterImagesItem | Record<string, FooterImagesItem>,
        footerImage2: FooterImagesItem | Record<string, FooterImagesItem>,
        htmlCopywriteText: {
            display: boolean
            text: string | Record<string, string>
        }
    }
}>()
const emits = defineEmits(['openContactPopup'])

const footerImage1 = computed(() => resolveImage(props.itemData.footerImage1))
const footerImage2 = computed(() => resolveImage(props.itemData.footerImage2))
const copywriteDisplay = computed(() => props.itemData.htmlCopywriteText?.display ?? false)
const copywriteText = computed(() => resolveText(props.itemData.htmlCopywriteText?.text || ''))
</script>
<style scoped>
.container {
    padding: 5px 15px 70px;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.6);
    font-size: 16px;
    background: rgb(2, 74, 73);
    font-weight: 400;
    font-family: system-ui;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
}
@media (max-width : 420px){
    .container{
       font-size: 14px; 
    }
}
</style>